import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import { Button, Form } from "devextreme-react";
import { Label, SimpleItem } from "devextreme-react/form";

import ButtonOKCancel from "./ButtonOKCancel";
import {
  updateLandscapeTitle,
  updateVerticalTitle,
} from "./Redux/axisTitleSlice";

export default function AxisTitleContainer(props) {
  const { axisTitleType, axisTitlePopupRef } = props;

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const onCancelClick = (e) => {
    axisTitlePopupRef.current.instance.hide();
  };

  const onOkClick = (e) => {
    if (axisTitleType === "LANDSCAPE") {
      dispatch(
        updateLandscapeTitle(
          formRef.current.instance.option("formData").axisTitle
        )
      );
    } else if (axisTitleType == "VERTICAL") {
      dispatch(
        updateVerticalTitle(
          formRef.current.instance.option("formData").axisTitle
        )
      );
    }

    axisTitlePopupRef.current.instance.hide();
  };

  const axisTitleEditorOptions = {
    value: null,
  };

  return (
    <React.Fragment>
      <Form ref={formRef}>
        <SimpleItem
          dataField="axisTitle"
          editorType="dxTextBox"
          editorOptions={axisTitleEditorOptions}
        >
          <Label text="제목" />
        </SimpleItem>
      </Form>
      <ButtonOKCancel onCancelClick={onCancelClick} onOkClick={onOkClick} />
    </React.Fragment>
  );
}
